import hero from './hero';
import story from './story';

const initialize = () => {

    hero.initialize();
    story.initialize();
};

export default {
    initialize,
};

